<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <notifications transition-name="notification-list" transition-mode="out-in">

    </notifications>
    <transition name="fade"
                mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
  // Loading some plugin css asynchronously
  import('sweetalert2/dist/sweetalert2.css');
  import('vue-notifyjs/themes/default.css');
  export default {};
</script>
<style lang="scss">
  .notifications {
    .notification-list-move {
      transition: transform 0.3s, opacity 0.4s;
    }
    .notification-list-item {
      display: inline-block;
      margin-right: 10px;

    }
    .notification-list-enter-active, .notification-list-leave-active {
      transition: opacity 0.4s;
    }
    .notification-list-enter, .notification-list-leave-to /* .list-leave-active for <2.1.8 */
    {
      opacity: 0;
    }
  }

  .sub-schema.el-collapse-item {
    padding: 0;
    margin-top: 0;
  }

  .ti-spin {
    display: inline-block;
    animation: rotating 2s linear infinite;
  }

  .vue-tabs .tab-content {
    text-align: left !important;
  }

  .el-message-box {
    min-width: 420px;
    max-height: calc(100% - 40px);
    max-width: calc(100% - 40px);
    width: auto !important;
    overflow: auto !important;
  }

  .el-table__body tr.current-row > td {
    background: #71c0ff !important;
  }

  .el-input.is-disabled .el-input__inner {
    background-color: white !important;
  }

  textarea.form-control {
    resize: vertical !important;
  }
</style>



// WEBPACK FOOTER //
// App.vue?2a60ead5